import { HTTPRequestMethod } from 'lib-shared-legacy-types';

import { ajaxSend } from 'api/api';

import type {
  DeleteFlowPayloadT,
  DeleteFlowResponseT,
  FetchFlowsFromNumbersPayloadT,
  FetchFlowsFromNumbersResponseT,
  GetQueryNumbersPagePayloadT,
  GetQueryNumbersPageResponseT,
} from './types';

const base = '/v1/flows';

export function fetchFlowsFromNumbers(
  payload: FetchFlowsFromNumbersPayloadT = { numbers: [] },
) {
  return ajaxSend<FetchFlowsFromNumbersResponseT>({
    path: `${base}?channel=pstnphone&numbers=${payload.numbers}`,
  });
}

export function deleteFlow(payload: DeleteFlowPayloadT) {
  return ajaxSend<DeleteFlowResponseT>({
    method: HTTPRequestMethod.Delete,
    path: `${base}/${payload.id}`,
  });
}

export function getQueryNumbersPage(payload: GetQueryNumbersPagePayloadT) {
  const { query } = payload;
  const limit = query?.limit ? `limit=${query.limit}` : '';
  const after = query?.after ? `&after=${encodeURIComponent(query.after)}` : '';
  const before = query?.before
    ? `&before=${encodeURIComponent(query.before)}`
    : '';

  return ajaxSend<GetQueryNumbersPageResponseT>({
    path: query?.path || `/v1/numbers?${limit}${after}${before}`,
  });
}
